export { default as LOGO } from '../assets/images/logo/beconnectlogo.jpg'
export { default as LOGO_DARK } from '../assets/images/logo/beconnectlogodark.jpg'
export const BE_CONNECT = 'https://www.be-connect.co.uk/'


export const USER_ROLES = {
    ADMIN: "AD",
    TEAM_LEAD: 'TL',
    ASSOCIATE: 'AS',
    CUSTOMER_SERVICE: 'CS',
    HR: 'HR',
    SUPER_ADMIN: 'SA'
}

export const getReadableRole = {
    'AD': 'Admin',
    'HR': 'Human Resource',
    'AS': 'Associate',
    'CS': 'Customer Service',
    'TL': 'Team Lead',
    'SA': 'Super Admin',
}




export const OFFICE_TIMING = {
    TOTAL_TIME: (9 * 60 * 60),
    WORK_TIME: (8 * 60 * 60),
    BREAK_TIME: 0
}

export const DEFAULT_PAGINATION_OPTION = {
    pageNumber: 1,
    pageSize: 20,
}

export const ATTENDANCE_MARK = {
    ABSENT: "AB",
    LATE: "L",
    PRESENT: "P",
    HALF_DAY: "HD",
    HOLIDAY: 'Holiday',
    OPTIONAL_HOLIDAY: 'OH',
    BANK_HOLIDAY: "BH",
    PAID_OFF: "PO",
    SICK_LEAVE: "SL",
    CASUAL_LEAVE: "CL",
    UNPAID_LEAVE: "UL",
    DAYS_NOT_ATTENDED: 'N/A'

}



export const LEAVE_STATUS = {
    PENDING: 'PENDING',
    ACCEPTED: 'ACCEPTED',
    REJECTED: 'REJECTED',
}

export const LEAVE_TYPES = {
    PAID_LEAVE: 'Paid Leave',
    UNPAID_LEAVE: 'Unpaid Leave',
    OPTIONAL_HOLIDAY: 'Optional Holiday'
}

export const ATTENDANCE_HISTORY_TYPE = {
    ATTENDANCE: 'ATTENDANCE',
    LEAVE: 'LEAVE'
}


export const PAGE_OPTIONS = [
    10, 20, 40, 50, 60, 100, 500
]



export const COUNTRY_DETAILS_TO_SELECT = "name,callingCodes,flags,alpha3Code"
export const UK_MOBILE_NUMBER_VALIDATION_REGEX = /^((\+44\s?)|(0))[0-9]{10}$/;
export const UK_ZIP_CODE_REGEX = /^[a-z]{1,2}\d[a-z\d]?\s*\d[a-z]{2}$/i;
export const IP_ADDRESS_VALIDATION = /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;


export const MESSAGE_TIMING = {
    EDIT: 5,
    DELETE: 10,
}

export const NOTIFICATION_TYPE =  {
    CHAT : 'chat',
    NOTIFICATION : 'notification',
    REMAINDERS : "remainders",
    OTHER : 'other'
}